import { render, staticRenderFns } from "./BJobChoice.vue?vue&type=template&id=470eb2b3&scoped=true&"
import script from "./BJobChoice.vue?vue&type=script&lang=js&"
export * from "./BJobChoice.vue?vue&type=script&lang=js&"
import style0 from "./BJobChoice.vue?vue&type=style&index=0&id=470eb2b3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470eb2b3",
  null
  
)

export default component.exports